module.exports = __webpack_public_path__ + "img/one-time-deposit-slide.677312ee.svg";